import '../core/globals';